/** Shared workforce document types — aligned with Documents hub design. */

export const DOCUMENT_TYPE_OPTIONS = [
  // Identity
  'Passport',
  'Driver Licence',
  'Own Transport Declaration',
  'Medicare Card',
  'Visa — 482 Skilled',
  'Visa — Other',
  // Compliance
  'Working With Children Check (WWCC)',
  'Cleaning License',
  'White Card',
  'Medical Cleaning Competency',
  'Kitchen Exhaust Cleaning Competency',
  'High Access / Ladder Competency',
  'Site Induction',
  // Employment
  'Employment Contract',
  'CV',
  'NDA',
  'Tax File Declaration',
  'Super Choice Form',
  // Certificates
  'First Aid Certificate',
  'Academic Document',
  'Experience Certificate',
  // Training
  'Induction Checklist',
  'Training Certificate',
  // Insurance
  'Insurance Certificate',
  'Contractor Insurance Certificate',
  // Police
  'Police Clearance',
  // Catch-all
  'Other',
];

export const DOCUMENT_TYPE_OPTGROUPS = [
  {
    label: 'Identity',
    options: [
      'Passport',
      'Driver Licence',
      'Own Transport Declaration',
      'Medicare Card',
      'Visa — 482 Skilled',
      'Visa — Other',
    ],
  },
  {
    label: 'Compliance',
    options: [
      'Working With Children Check (WWCC)',
      'Cleaning License',
      'White Card',
      'Medical Cleaning Competency',
      'Kitchen Exhaust Cleaning Competency',
      'High Access / Ladder Competency',
      'Site Induction',
    ],
  },
  {
    label: 'Employment',
    options: [
      'Employment Contract',
      'CV',
      'NDA',
      'Tax File Declaration',
      'Super Choice Form',
    ],
  },
  {
    label: 'Certificates',
    options: [
      'First Aid Certificate',
      'Academic Document',
      'Experience Certificate',
    ],
  },
  {
    label: 'Training',
    options: ['Induction Checklist', 'Training Certificate'],
  },
  {
    label: 'Insurance',
    options: ['Insurance Certificate', 'Contractor Insurance Certificate'],
  },
  {
    label: 'Police Clearance',
    options: ['Police Clearance'],
  },
  {
    label: 'Custom',
    options: ['Other'],
  },
];

export const DOCUMENT_CATEGORY_TYPES = {
  Identity: [
    'Passport',
    'Driver Licence',
    'Own Transport Declaration',
    'Medicare Card',
    'Visa — 482 Skilled',
    'Visa — Other',
  ],
  Compliance: [
    'Working With Children Check (WWCC)',
    'Cleaning License',
    'White Card',
    'Medical Cleaning Competency',
    'Kitchen Exhaust Cleaning Competency',
    'High Access / Ladder Competency',
    'Site Induction',
  ],
  Employment: [
    'Employment Contract',
    'CV',
    'NDA',
    'Tax File Declaration',
    'Super Choice Form',
  ],
  Certificates: [
    'First Aid Certificate',
    'Academic Document',
    'Experience Certificate',
  ],
  Training: ['Induction Checklist', 'Training Certificate'],
  Insurance: ['Insurance Certificate', 'Contractor Insurance Certificate'],
  'Police Clearance': ['Police Clearance'],
  Custom: ['Other'],
};

export function categorizeDocumentType(documentType = '') {
  const raw = String(documentType || '').trim();
  if (!raw) return 'Custom';

  for (const [category, types] of Object.entries(DOCUMENT_CATEGORY_TYPES)) {
    if (types.some((t) => t.toLowerCase() === raw.toLowerCase())) {
      return category;
    }
  }

  const t = raw.toLowerCase();
  if (/passport|driver|medicare|visa|identity|id card|licence|license/.test(t))
    return 'Identity';
  if (/wwcc|children|white card|cleaning/.test(t)) return 'Compliance';
  if (/contract|cv|resume|nda|tax|super|employment|offer/.test(t))
    return 'Employment';
  if (/first aid|academic|experience|certificate|qualification/.test(t))
    return 'Certificates';
  if (/training|induction|course/.test(t)) return 'Training';
  if (/insurance|cover|liability/.test(t)) return 'Insurance';
  if (/police|clearance|background/.test(t)) return 'Police Clearance';
  return 'Custom';
}
